import React from 'react';

export const SnowIcon = () => (
  <svg
    className="weather-icon"
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" stroke="#000000" strokeLinecap="round" strokeWidth="1.5">
      {/* Top snowflake - smaller */}
      <line x1="8" x2="8" y1="4" y2="9" />
      <line x1="5.5" x2="10.5" y1="6.5" y2="6.5" />
      <line x1="6.2" x2="9.8" y1="5" y2="8" />
      <line x1="9.8" x2="6.2" y1="5" y2="8" />

      {/* Middle snowflake - medium */}
      <line x1="18" x2="18" y1="10" y2="16" />
      <line x1="15" x2="21" y1="13" y2="13" />
      <line x1="16" x2="20" y1="11" y2="15" />
      <line x1="20" x2="16" y1="11" y2="15" />

      {/* Bottom snowflake - larger */}
      <line x1="10" x2="10" y1="18" y2="26" />
      <line x1="6" x2="14" y1="22" y2="22" />
      <line x1="7.5" x2="12.5" y1="19.5" y2="24.5" />
      <line x1="12.5" x2="7.5" y1="19.5" y2="24.5" />
    </g>
  </svg>
);
